"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus");

var _vuex = require("vuex");

var _utils = require("@/helpers/utils");

var _factures = require("@/helpers/factures");

var _fileSaver = require("file-saver");

var _moment = _interopRequireDefault(require("moment"));

var _listClient = _interopRequireDefault(require("@/components/listClient"));

var _listEnseigne = _interopRequireDefault(require("@/components/listEnseigne"));

var _exportModuleMixin = _interopRequireDefault(require("@/mixins/exportModuleMixin"));

var _exportListMixin = _interopRequireDefault(require("@/mixins/exportListMixin"));

var Excel = _interopRequireWildcard(require("exceljs"));

var _StickyTable = _interopRequireDefault(require("@/components/StickyTable.vue"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination.vue"));

var _ScrollBar = _interopRequireDefault(require("@/components/ScrollBar.vue"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'CreanceList',
  components: {
    StickyTable: _StickyTable.default,
    Pagination: _Pagination.default,
    ScrollBar: _ScrollBar.default,
    ListClient: _listClient.default,
    ListEnseigne: _listEnseigne.default
  },
  mixins: [_exportModuleMixin.default, _exportListMixin.default],
  data: function data() {
    return {
      dataTable: [],
      currentPage: 1,
      pageSize: 100,
      show: false,
      activeFilter: '',
      affaires: {
        options: [],
        list: [],
        loading: false
      },
      columns: {
        'secteur_geo': {
          key: 0,
          prop: 'secteur_geo_libelle',
          label: 'Code géo.',
          width: 150
        },
        'client': {
          key: 1,
          prop: 'client_libelle',
          label: 'Client',
          width: 200
        },
        'enseigne': {
          key: 2,
          prop: 'enseigne_libelle',
          label: 'Enseigne',
          width: 300
        },
        'commande': {
          key: 3,
          prop: 'commande_numero',
          label: 'Commande',
          width: 300
        },
        'affaire': {
          key: 4,
          prop: 'affaire_nom',
          label: 'Nom affaire',
          width: 450
        },
        'affaire.num_affaire': {
          key: 5,
          prop: 'affaire_num_affaire',
          label: 'N° affaire',
          width: 300
        },
        'facture.date_facture': {
          key: 6,
          prop: 'facture_date_facture',
          label: 'Date',
          width: 110
        },
        'facture.numero': {
          key: 7,
          prop: 'facture_numero',
          label: 'Numéro',
          width: 110
        },
        'facture.libelle': {
          key: 8,
          prop: 'facture_libelle',
          label: 'Libellé',
          width: 400
        },
        'facture.retenue_garantie': {
          key: 9,
          prop: 'facture_retenue_garantie',
          label: 'R.G.',
          width: 120
        },
        'facture.mt_avant_paiement_direct_ttc': {
          key: 10,
          prop: 'facture_mt_avant_paiement_direct_ttc',
          label: 'TTC avant P.D.',
          width: 120
        },
        'facture.mt_a_percevoir_ttc': {
          key: 11,
          prop: 'facture_mt_a_percevoir_ttc',
          label: 'TTC après P.D.',
          width: 120
        },
        'facture.date_echeance': {
          key: 12,
          prop: 'facture_date_echeance',
          label: 'Échéance',
          width: 110
        },
        'facture.mt_regle': {
          key: 13,
          prop: 'facture_mt_regle',
          label: 'Montant',
          width: 120
        },
        'reglement.date': {
          key: 14,
          prop: 'reglement_date',
          label: 'Date',
          width: 110
        },
        'reglement.mode': {
          key: 15,
          prop: 'reglement_mode',
          label: 'Mode',
          width: 100
        },
        'facture.solde': {
          key: 16,
          prop: 'facture_solde',
          label: 'Solde',
          width: 120
        },
        'facture.commentaire': {
          key: 17,
          prop: 'facture_commentaire',
          label: 'Commentaire',
          width: 250
        }
      },
      dialogDetailVisible: false,
      dialogFactureCommentaireVisible: false,
      sortMethod: {
        facture_numero: function facture_numero(a, b) {
          var numA = a.split('.').map(Number);
          var numB = b.split('.').map(Number);

          for (var i = 0; i < Math.max(numA.length, numB.length); i++) {
            var partA = numA[i] || 0; // Si une partie est absente, considérer comme 0

            var partB = numB[i] || 0;

            if (partA !== partB) {
              return partA - partB; // Trier par différence numérique
            }
          }

          return 0; // Si tous les segments sont égaux
        },
        reglement_date: function reglement_date(a, b) {
          if (a === null && b === null) {
            return 0;
          }

          if (a === null) {
            return -1;
          }

          if (b === null) {
            return 1;
          }

          return a > b ? 1 : a < b ? -1 : 0;
        },
        facture_commentaire: function facture_commentaire(a, b) {
          if (a === null && b === null) {
            return 0;
          }

          if (a === null) {
            return -1;
          }

          if (b === null) {
            return 1;
          }

          return a > b ? 1 : a < b ? -1 : 0;
        },
        commande_numero: function commande_numero(a, b) {
          if (a === null && b === null) {
            return 0;
          }

          if (a === null) {
            return -1;
          }

          if (b === null) {
            return 1;
          }

          return a > b ? 1 : a < b ? -1 : 0; // return a.numero < b.numero
        }
      },
      filters: [// Filtre #0 : recherche globale sur champs multiples
      {
        value: '',
        prop: ['affaire', 'commande', 'facture', 'reglements'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'affaire':
                var numAffaire = row.affaire.num_affaire.toLowerCase();
                return numAffaire.indexOf(filter.value.toLowerCase()) > -1;

              case 'facture':
                return Object.keys(row.facture).some(function (propFacture) {
                  switch (propFacture) {
                    case 'date_facture':
                    case 'date_echeance':
                      var date = row.facture[propFacture];

                      if (!date || typeof date === 'undefined') {
                        return false;
                      }

                      return (0, _moment.default)(String(date)).format('DD/MM/YYYY').indexOf(filter.value) > -1;

                    default:
                      return false;
                  }
                });

              /*
              case 'commande':
                return row[prop] !== null && String(row[prop].numero).toLowerCase().indexOf(filter.value) > -1
              case 'montant':
              case 'montant_ht':
              case 'montant_regle':
              case 'mt_a_percevoir_ttc':
                return String(toCurrencyFilter(row[prop])).indexOf(filter.value.toLowerCase()) > -1
              */

              default:
                return false;
            }
          });
        }
      }, // Filtre #1 : si la date de facturation est >= date de début de période
      {
        value: '',
        prop: ['facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_facture;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrAfter(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #2 : si la date de facturation est <= date de fin de période
      {
        value: '',
        prop: ['facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_facture;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrBefore(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #3 : si une des dates de règlement est >= date de début de période
      {
        value: '',
        prop: ['reglements'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'reglements':
                if (filter.value === null) {
                  return true;
                }

                if (row.reglements.length === 0) {
                  return false;
                } // console.log(row.reglements.filter(x => moment(String(x.date), 'YYYY-MM-DD').isSameOrAfter(filter.value)).length, ' règlement(s) correspondant(s) : >= ', filter.value)


                return row.reglements.filter(function (x) {
                  return (0, _moment.default)(String(x.date), 'YYYY-MM-DD').isSameOrAfter(filter.value);
                }).length > 0;

              default:
                return false;
            }
          });
        }
      }, // Filtre #4 : si une des dates de règlement est <= date de fin de période
      {
        value: '',
        prop: ['reglements'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'reglements':
                if (filter.value === null) {
                  return true;
                }

                if (row.reglements.length === 0) {
                  return false;
                } // console.log(row.reglements.filter(x => moment(String(x.date), 'YYYY-MM-DD').isSameOrBefore(filter.value)).length, ' règlement(s) correspondant(s) : <= ', filter.value)


                return row.reglements.filter(function (x) {
                  return (0, _moment.default)(String(x.date), 'YYYY-MM-DD').isSameOrBefore(filter.value);
                }).length > 0;

              default:
                return false;
            }
          });
        }
      }, // Filtre #5 : recherche sur le numéro de l'affaire
      {
        value: '',
        prop: ['affaire'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'affaire':
                var numAffaire = row.affaire.num_affaire.toLowerCase();
                return numAffaire.indexOf(filter.value.toLowerCase()) > -1;

              default:
                return false;
            }
          });
        }
      }, // Filtre #6 : si le montant TTC propre est >= montant saisie
      {
        value: '',
        prop: ['facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_a_percevoir_ttc;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #7 : si le montant TTC propre est <= montant saisie
      {
        value: '',
        prop: ['facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_a_percevoir_ttc;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #8 : si la date d'échéance' est >= date de début de période
      {
        value: '',
        prop: ['facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_echeance;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrAfter(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #9 : si la date d'échéance' est <= date de fin de période
      {
        value: '',
        prop: ['facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_echeance;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrBefore(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #10 : filtre sur le client
      {
        value: null,
        prop: ['affaire'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'affaire':
                if (filter.value === null) {
                  return true;
                }

                return row.affaire.client.id === filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #11 : filtre sur l'enseigne
      {
        value: null,
        prop: ['affaire'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'affaire':
                if (filter.value === null) {
                  return true;
                }

                return row.affaire.enseigne.id === filter.value;

              default:
                return false;
            }
          });
        }
      }, // Filtre #12 : recherche facture soldées OU non-soldées
      {
        value: 'non-soldee',
        prop: ['facture_solde'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_solde':
                if (filter.value.toLowerCase() === 'soldee') {
                  return row.facture_solde === 0;
                }

                return row.facture_solde !== 0;

              default:
                return false;
            }
          });
        }
      }],
      mixinEvents: {
        export: 'CREANCES_EXPORT',
        exported: 'CREANCES_EXPORTED'
      },
      multipleSelection: [],
      row: [],
      rowComment: {},
      rowSpan: {
        label: 4,
        field: 5
      }
    };
  },
  watch: {
    filters: {
      deep: true,
      handler: function handler(newValue) {
        this.getData();
      }
    }
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {}, (0, _vuex.mapGetters)('facturation', ['getCreanceList']), {
    dateFormat: function dateFormat() {
      return this.user.date_format; // dd/MM/yyyy
    },
    filterExists: function filterExists() {
      var filterExists = false;
      this.filters.forEach(function (x, index) {
        // console.log(index + '# typeof', x.value, typeof x.value)
        switch (_typeof(x.value)) {
          case 'string':
            if (x.value !== null && x.value !== '') {
              // console.log('A.' + index + '# typeof', x.value, typeof x.value)
              filterExists = true;
            }

            break;

          case 'number':
            if (x.value !== null && x.value > 0) {
              // console.log('B.' + index + '# typeof', x.value, typeof x.value)
              filterExists = true;
            }

            break;

          case 'object':
            if (x.value && x.value !== null && x.value.length > 0) {
              // console.log('C.' + index + '# typeof', x.value, typeof x.value)
              filterExists = true;
            }

            break;
        }
      });
      return filterExists;
    },
    rowCommentHtml: function rowCommentHtml() {
      return (0, _utils.nl2br)(this.rowComment.commentaire);
    },
    pageIdent: function pageIdent() {
      return "".concat(this.user.id_societe, "-VenteCreance-CreancesClients");
    },
    total: function total() {
      return this.dataTable.length;
    }
  }),
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      var savedFilters, filters;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Récupération des filtres sauvegardés
              savedFilters = localStorage.getItem("Filters_".concat(this.pageIdent));

              if (savedFilters) {
                filters = JSON.parse(savedFilters);
                filters.forEach(function (row, index) {
                  _this.filters[index].value = row;
                });
              }

              _context.next = 4;
              return this.getCreances();

            case 4:
              _context.next = 6;
              return this.getData();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  methods: _objectSpread({}, (0, _vuex.mapActions)('facturation', ['getCreances', 'setCreanceCommentaire']), {
    getData: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var filters;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$loader(true);
                this.show = false; // Sauvegarde des filtres dans le localStorage

                filters = this.filters.map(function (filter) {
                  return filter.value;
                });
                localStorage.setItem("Filters_".concat(this.pageIdent), JSON.stringify(filters)); // Filtrage des données en fonction des filtres

                _context2.next = 6;
                return this.applyFilters();

              case 6:
                this.$loader(false);
                this.show = true;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    applyFilters: function applyFilters() {
      var _this2 = this;

      var data = this.getCreanceList;
      var filteredData = data.filter(function (row) {
        return _this2.filters.every(function (filter) {
          if (!filter.value || filter.value === '') {
            // Si la valeur du filtre est vide, passer au suivant
            return true;
          } // Appliquer la fonction de filtre


          return filter.filterFn(row, filter);
        });
      });
      this.dataTable = filteredData; // récupération de la liste des affaires pour l'autocomplétion du champ de recherche Num affaire

      var listAffaire = [];
      this.dataTable.forEach(function (row) {
        var value = row.affaire.num_affaire;
        var label = value;

        if (!listAffaire.find(function (item) {
          return item.value === value;
        })) {
          listAffaire.push({
            value: value,
            label: label
          });
        }
      });
      this.affaires.list = listAffaire;
    },
    actionEditCommentaire: function actionEditCommentaire() {
      var _this3 = this;

      this.dialogFactureCommentaireVisible = false;
      this.$loader(true);
      this.setCreanceCommentaire(this.rowComment).then(function (_) {
        _this3.$message('Mise à jour du commentaire effectuée avec succès'); // this.resetForm()


        _this3.$loader(false);

        _this3.dialogFactureCommentaireVisible = false;
      }).catch(function (error) {
        _this3.$loader(false);

        _this3.dialogFactureCommentaireVisible = false;

        _this3.$message(error);
      });
    },
    formatSecteurGeo: function formatSecteurGeo(row, column, cellValue, index) {
      // console.log('---')
      // console.log('row', row)
      // console.log('column', column)
      // console.log('cellValue', cellValue)
      // console.log('index', index)
      return row.affaire.secteur_geo_libelle;
    },
    generateExcelFile: function () {
      var _generateExcelFile = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var workbook, worksheet, columnHeaderList, cellStart, cellEnd, data, totalMontantReglement, rowCount, style, columnStyle, cellFirst, cellLast, buffer, now, fileType, fileExtension, file, blob;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('[CreanceList] generateExcelFile called!'); // Classeur Excel

                workbook = new Excel.Workbook(); // Propriétés du classeur

                workbook.creator = 'Groupe MARRAUD - EASY';
                workbook.lastModifiedBy = 'Groupe MARRAUD - EASY'; // workbook.lastPrinted = ''

                workbook.created = new Date(); // workbook.modified = ''

                workbook.company = 'Groupe MARRAUD';
                workbook.manager = '';
                workbook.title = 'Export Créances clients';
                workbook.subject = '';
                workbook.keywords = 'créances clients';
                workbook.category = '';
                workbook.description = 'Créances / Ventes : Créances clients'; // workbook.language = ''
                // workbook.revision = ''
                // workbook.contentStatus = ''
                // Forcer les calculs au chargement du classeur

                workbook.calcProperties.fullCalcOnLoad = true; // Feuille de calcul avec en-tête et pied de page

                worksheet = workbook.addWorksheet('Créances clients', {
                  properties: {
                    defaultRowHeight: 15
                  },
                  headerFooter: {
                    firstHeader: 'Groupe MARRAUD - EASYs - &A',
                    firstFooter: '&L&D à &T&C&F&RPage &P sur &N'
                  },
                  views: [// Viger les volets sous la seconde ligne
                  {
                    state: 'frozen',
                    xSplit: 0,
                    ySplit: 2
                  }] // state: 'frozen',
                  // xSplit: 0,
                  // ySplit: 1,
                  // topLeftCell: 'A2'
                  // activeCell: 'A1',
                  // autoFilter: {
                  //   from: 'A1',
                  //   to: 'D1'
                  // }

                }); // Add column headers and define column keys and widths
                // Note: these column structures are a workbook-building convenience only,
                // apart from the column width, they will not be fully persisted.
                // Colonnes d'en-tête

                columnHeaderList = this.getColumnHeaderList(); // worksheet.getRow(2).values = columnHeaderList.map(x => x.header)

                worksheet.getRow(2).values = columnHeaderList.map(function (x) {
                  return x.header;
                }); // Cellules de la première ligne d'en-tête (certaines doivent être fusionnées)

                // Factures : cellules fusionnées
                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'facture');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'facture');

                if (cellStart && cellEnd) {
                  // console.log(`${cellStart.c}1:${cellEnd.c}1 --> Commande`)
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Facture';
                } // Règlement : cellules fusionnées


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'reglement');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'reglement');

                if (cellStart && cellEnd) {
                  // console.log(`${cellStart.c}1:${cellEnd.c}1 --> Règlement`)
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Règlement';
                } // Affaire : cellules fusionnées


                cellStart = this.getFirstColumnHeaderByGroup(columnHeaderList, 'affaire');
                cellEnd = this.getLastColumnHeaderByGroup(columnHeaderList, 'affaire');

                if (cellStart && cellEnd) {
                  // console.log(`${cellStart.c}1:${cellEnd.c}1 --> Affaire`)
                  worksheet.mergeCells("".concat(cellStart.c, "1:").concat(cellEnd.c, "1"));
                  worksheet.getCell("".concat(cellStart.c, "1")).value = 'Affaire';
                } // Définition des colonnes d'en-tête
                // worksheet.columns = columnHeaderList


                worksheet.columns = columnHeaderList.map(function (x) {
                  return {
                    key: x.key,
                    width: x.width
                  };
                }); // Données

                data = this.getPreparedDataForExport();
                totalMontantReglement = 0;
                data.forEach(function (row) {
                  worksheet.addRow(row); // Numéro de la ligne ajoutée

                  var n = worksheet.rowCount; // Nombre de réglements pour la ligne de facture

                  var nbReglements = row.reglements.length;

                  if (nbReglements > 0) {
                    // Calcul du montant cumulé des règements pour avoir une somme cohérente en pied de colonne
                    row.reglements.forEach(function (reglement) {
                      totalMontantReglement += reglement.montant;
                    });

                    if (nbReglements > 1) {
                      // On fusione les cellules date et montant
                      worksheet.mergeCells("J".concat(n, ":K").concat(n));
                      worksheet.getCell("J".concat(n)).value = "".concat(nbReglements, " r\xE8glements"); // On indique qu'il s'agit de réglement multiple

                      worksheet.getCell("L".concat(n)).value = "multiple (".concat(nbReglements, ")");
                    }
                  } else {
                    // Aucun réglement
                    // On fusione les cellules date et montant
                    worksheet.mergeCells("J".concat(n, ":K").concat(n));
                    worksheet.getCell("J".concat(n)).value = 'aucune règlement';
                    worksheet.getCell("L".concat(n)).value = '-';
                  }
                }); // Totaux

                worksheet.addRow({
                  commande_numero: 'Total',
                  affaire_num_affaire: '',
                  facture_retenue_garantie: 0,
                  facture_mt_avant_paiement_direct_ttc: 0,
                  facture_mt_a_percevoir_ttc: 0,
                  reglement_montant: totalMontantReglement,
                  facture_solde: 0
                }); // Mémorisation du numéro de la dernière ligne

                rowCount = worksheet.rowCount; // Formule de calcul de la cellule "maître"

                worksheet.getCell("F".concat(rowCount)).value = {
                  formula: "SUM(F3:F".concat(rowCount - 1, ")"),
                  shareType: 'shared',
                  ref: "F".concat(rowCount, ":M").concat(rowCount),
                  date1904: false
                }; // Application de la formule de calcul sur les cellules "esclaves"

                worksheet.getCell("G".concat(rowCount)).value = {
                  sharedFormula: "F".concat(rowCount),
                  date1904: false
                };
                worksheet.getCell("H".concat(rowCount)).value = {
                  sharedFormula: "F".concat(rowCount),
                  date1904: false
                }; // worksheet.getCell(`K${rowCount}`).value = { sharedFormula: `F${rowCount}`, date1904: false }

                worksheet.getCell("M".concat(rowCount)).value = {
                  sharedFormula: "F".concat(rowCount),
                  date1904: false
                }; // Style et formatage génériques

                style = {
                  // en-tête
                  header: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FFFFFFFF'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FF000000'
                      }
                    },
                    alignment: {
                      vertical: 'middle',
                      horizontal: 'center'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // lignes paires
                  even: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFDDDDDD'
                      }
                    }
                  },
                  // lignes impaires
                  odd: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    }
                  }
                };
                // Boucle sur les lignes de la feuille du classeur
                worksheet.eachRow(function (row, rowNumber) {
                  // Boucle sur les cellules de la ligne
                  row.eachCell({
                    includeEmpty: true
                  }, function (cell, colNumber) {
                    switch (rowNumber) {
                      // Ligne d'en-tête
                      case 1:
                      case 2:
                        cell.style = _objectSpread({}, style.header);
                        break;
                      // Ligne de pied du tableur

                      case rowCount:
                        columnStyle = columnHeaderList[colNumber - 1].style || {};
                        cell.style = Object.assign({}, cell.style, columnStyle, _objectSpread({}, style.header, {
                          alignment: {
                            horizontal: 'right'
                          }
                        }));
                        break;
                      // Données

                      default:
                        columnStyle = columnHeaderList[colNumber - 1].style || {};
                        var cellStyle = {}; // Lignes paires

                        if (rowNumber % 2 === 0) {
                          cellStyle = _objectSpread({}, style.even);
                        } else {
                          cellStyle = _objectSpread({}, style.odd);
                        }

                        cell.style = Object.assign({}, cell.style, columnStyle, cellStyle);
                        break;
                    }
                  });
                }); // Cellules d'en-tête

                worksheet.getCell('Q1').style = _objectSpread({}, style.header);
                worksheet.getCell('R1').style = _objectSpread({}, style.header); // Cellules de la ligne des totaux (dernière ligne)

                worksheet.getCell("N".concat(rowCount)).style = _objectSpread({}, style.header);
                worksheet.getCell("O".concat(rowCount)).style = _objectSpread({}, style.header);
                worksheet.getCell("P".concat(rowCount)).style = _objectSpread({}, style.header);
                worksheet.getCell("Q".concat(rowCount)).style = _objectSpread({}, style.header);
                worksheet.getCell("R".concat(rowCount)).style = _objectSpread({}, style.header);
                cellFirst = this.getFirstColumnHeader(columnHeaderList);
                cellLast = this.getLastColumnHeader(columnHeaderList); // Set an auto filter

                worksheet.autoFilter = {
                  from: "".concat(cellFirst.c, "2"),
                  to: "".concat(cellLast.c, "2")
                }; // Ecriture dans un nouveau buffer

                _context3.next = 49;
                return workbook.xlsx.writeBuffer();

              case 49:
                buffer = _context3.sent;
                // Paramètres du fichier généré dynamiquement
                now = (0, _utils.getDateNow)().format('YYYYMMDD-HHmmss'); // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'

                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileExtension = 'xlsx';
                file = "".concat(now, "-creances-clients.").concat(fileExtension); // Création du Blob

                blob = new Blob([buffer], {
                  type: fileType
                }); // Servir le fichier via le navigateur client

                (0, _fileSaver.saveAs)(blob, file);
                console.log('[CreanceList] generateExcelFile called');

              case 57:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function generateExcelFile() {
        return _generateExcelFile.apply(this, arguments);
      }

      return generateExcelFile;
    }(),
    getColumnHeaderList: function getColumnHeaderList() {
      var defaultStyles = {
        monetaire: {
          numFmt: '# ##0.00 "€";[Red]-# ##0.00 "€"',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        pourcentage: {
          numFmt: '##0.00%',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        date: {
          numFmt: 'dd/mm/yyyy',
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        nombre: {
          numFmt: '0',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        }
      }; // Colonnes d'en-tête

      var columnHeaderList = [//
      {
        header: 'Numéro',
        key: 'commande_numero',
        width: 20,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, {
        header: 'N° Affaire',
        key: 'affaire_num_affaire',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, // Factures
      {
        header: 'Date',
        group: 'facture',
        key: 'facture_date_facture',
        width: 13,
        style: defaultStyles.date
      }, {
        header: 'Numéro',
        group: 'facture',
        key: 'facture_numero',
        width: 20,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, {
        header: 'Libellé',
        group: 'facture',
        key: 'facture_libelle',
        width: 17,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, {
        header: 'R.G.',
        group: 'facture',
        key: 'facture_retenue_garantie',
        width: 17,
        style: defaultStyles.monetaire
      }, {
        header: 'TTC avant P.D.',
        group: 'facture',
        key: 'facture_mt_avant_paiement_direct_ttc',
        width: 17,
        style: defaultStyles.monetaire
      }, {
        header: 'TTC après P.D.',
        group: 'facture',
        key: 'facture_mt_a_percevoir_ttc',
        width: 17,
        style: defaultStyles.monetaire
      }, {
        header: 'Échéance',
        group: 'facture',
        key: 'facture_date_echeance',
        width: 13,
        style: defaultStyles.date
      }, // Règlements
      {
        header: 'Date',
        group: 'reglement',
        key: 'reglement_date',
        width: 13,
        style: defaultStyles.date
      }, {
        header: 'Montant',
        group: 'reglement',
        key: 'reglement_montant',
        width: 17,
        style: defaultStyles.monetaire
      }, {
        header: 'Mode',
        group: 'reglement',
        key: 'reglement_mode',
        width: 25,
        style: {
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        }
      }, {
        header: 'Solde',
        group: 'reglement',
        key: 'facture_solde',
        width: 25,
        style: defaultStyles.monetaire
      }, //
      {
        header: 'Commentaire',
        group: 'reglement',
        key: 'facture_commentaire',
        width: 80,
        style: {
          alignment: {
            vertical: 'top',
            wrapText: true
          }
        }
      }, // Affaires
      {
        header: 'Code géo.',
        group: 'affaire',
        key: 'secteur_geo_libelle',
        width: 10 + 4,
        style: {
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        }
      }, {
        header: 'Nom',
        group: 'affaire',
        key: 'affaire_nom',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, //
      {
        header: 'Enseigne',
        key: 'enseigne_libelle',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, {
        header: 'Client',
        key: 'client_libelle',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }];
      var columnName = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      columnHeaderList.forEach(function (x, index) {
        x.c = columnName[index];
        x.position = index + 1;
      });
      return columnHeaderList;
    },
    getPreparedDataForExport: function getPreparedDataForExport() {
      // On utilise les données pré-filtrées par le dataTable
      var data = this.$refs.dataTable.tableData;
      data.forEach(function (row) {
        // Dates
        // Attention : pour les transpositions de dates EN -> FR
        // on assigne la valeur transposée de row.{object}.date
        // à la propriété racine row.{object_prop_with_date}
        // sinon on transposerais à chaque fois la même date
        // et cela donnerait des dates invalides
        row.facture_date_facture = row.facture.date_facture ? (0, _utils.toDate)(row.facture.date_facture) : null;
        row.facture_date_echeance = row.facture.date_echeance ? (0, _utils.toDate)(row.facture.date_echeance) : null;

        if (row.reglements.length === 1) {
          row.reglement_date = row.reglements[0].date ? (0, _utils.toDate)(row.reglements[0].date) : null; // Mode de règlement

          row.reglement_mode = row.reglements[0].mode ? (0, _utils.getLabelModeReglement)(row.reglements[0].mode) : null;
        }
      });
      return data;
    },
    getColumnHeaderByKey: function getColumnHeaderByKey() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return data.find(function (x) {
        return x.key === key;
      });
    },
    getFirstColumnHeader: function getFirstColumnHeader() {
      var cells = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position < accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getLastColumnHeader: function getLastColumnHeader() {
      var cells = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position > accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getFirstColumnHeaderByGroup: function getFirstColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position < accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getLastColumnHeaderByGroup: function getLastColumnHeaderByGroup() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var cells = data.filter(function (x) {
        return x.group === groupName;
      });

      if (cells.length > 0) {
        return cells.reduce(function (accumulator, x) {
          // console.log(`x.position = ${x.position}`, 'accumulator', accumulator, typeof accumulator)
          return x.position > accumulator.position ? x : accumulator;
        }, cells[0]);
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (column.property === 'facture_libelle') {
          sums[index] = 'Total';
          return;
        }

        if (!['facture_retenue_garantie', 'facture_mt_avant_paiement_direct_ttc', 'facture_mt_a_percevoir_ttc', 'facture_mt_regle', 'facture_solde'].includes(column.property)) {
          sums[index] = '';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        sums[index] = (0, _utils.getTotal)(values); // Formattage

        if (column.property === 'facture_retenue_garantie' || column.property === 'facture_mt_avant_paiement_direct_ttc' || column.property === 'facture_mt_a_percevoir_ttc' || column.property === 'facture_mt_regle' || column.property === 'facture_solde') {
          sums[index] = (0, _utils.toCurrency)(sums[index]);
        }
      });
      return sums;
    },

    /* ---------------------------------------
     *  Liste déroulante des actions
     * ---------------------------------------
     *
     *   - paiement: créer un règlement normal
     *   - commentaire: ajout d'un commentaire à la facture
     *   - visualiser: voir le fichier uploadé
     *   - règlements: voir la liste des règlements de la facture
     *
     */
    handleCommand: function handleCommand(command) {
      switch (command.action) {
        case 'paiement':
          this.handleManageReglement(command.index, command.row, 'REGLEMENT_NEW');
          break;

        case 'commentaire':
          // Afficher une fenêtre modale d'édition de commentaire
          this.rowComment = {
            id: command.row.facture.id,
            commentaire: command.row.facture.commentaire,
            numero: command.row.facture.numero
          };
          this.dialogFactureCommentaireVisible = true;
          break;

        case 'visualiser':
          var facture = {
            id: command.row.facture.id,
            fichier: command.row.facture.fichier,
            nom_original: command.row.facture.nom_original
          };
          window.open((0, _factures.getFactureFichierUri)(facture), '_PDF_FACTURE');
          break;

        case 'reglements':
          this.handleManageReglement(command.index, command.row);
          break;
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.row = val;
      this.dialogDetailVisible = true;
    },
    handleManageReglement: function handleManageReglement(index, row) {
      var nextTickEventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      // this.$router.push({ name: 'VenteCreance.Creances.Reglements.ListByFacture', params: { factureId: parseInt(row.facture.id) } })
      _eventBus.EventBus.$emit('CREANCES_REGLEMENTS', 'reglements_by_facture', row, nextTickEventName); // EventBus.$emit('CREANCES_REGLEMENTS', 'reglements_by_facture', row)

    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (row.reglements.length !== 1) {
        if (column.property === 'reglement_date') {
          return {
            colspan: 2,
            rowspan: 1
          };
        } else if (column.property === 'facture_mt_regle') {
          return {
            colspan: 0,
            rowspan: 0
          };
        }
      }
    },
    searchAffaireByNumero: function searchAffaireByNumero(query) {
      var _this4 = this;

      if (query !== '') {
        this.affaires.loading = true;
        setTimeout(function () {
          _this4.affaires.loading = false;
          _this4.affaires.options = _this4.affaires.list.filter(function (item) {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.affaires.options = [];
      }
    },
    showNbReglement: function showNbReglement(reglements) {
      return "".concat(reglements.length, " r\xE8glement").concat(reglements.length > 1 ? 's' : '');
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;
      return row.facture_echeance_depassee === 1 && row.facture_solde !== 0 ? 'echeance-depassee' : '';
    }
  })
};
exports.default = _default;